import { defaultDraftCalculatorId as modalCalculatorId } from '../../core/reducers/financialCalculators';
import { selectIsPriceBreakdownModalOpen, togglePriceBreakdownModal } from '../../core/reducers/ui';
import { useAppDispatch, useAppSelector } from '../../core/utils';
const usePriceBreakdownModal = () => {
    const dispatch = useAppDispatch();
    const isModalOpen = useAppSelector(selectIsPriceBreakdownModalOpen);
    const openModal = () => {
        dispatch(togglePriceBreakdownModal(true));
    };
    const closeModal = () => {
        dispatch(togglePriceBreakdownModal(false));
    };
    const submitModalForm = () => {
        closeModal();
    };
    return {
        modalCalculatorId,
        isModalOpen,
        openModal,
        closeModal,
        submitModalForm,
    };
};
export default usePriceBreakdownModal;
